module.exports = __webpack_public_path__ + "img/588x310-04.6d0be4c6.png";